import { render, staticRenderFns } from "./LoanProductDetailed.vue?vue&type=template&id=6c66f13a"
import script from "./LoanProductDetailed.vue?vue&type=script&lang=js"
export * from "./LoanProductDetailed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports